<template>
  <div style="margin-top: 8px">
    <div class="story-wrapper">
      <history-modal />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useHeadSafe } from '@unhead/vue';
import { useI18n } from '#imports';

const { t } = useI18n();

useHeadSafe({
  title: t('storyHeadTitle')
});
</script>

<style scoped lang="scss">
.story-wrapper {
  position: relative;
}
</style>
